/**
 * Hidrata slides 2+ del carrusel: las URLs viven solo en data-* del <picture>
 * hasta que el slide se va a mostrar. No hay hidratación masiva en load/idle.
 */
(function () {
  const slidesCache = new WeakMap();

  function hydrateDeferredSlidePicture(picture) {
    if (!picture || !picture.hasAttribute('data-deferred-slide')) return;

    const fallbackSrc = picture.getAttribute('data-fallback-src');
    const desktopSrcset = picture.getAttribute('data-desktop-srcset');
    const mobileSrcset = picture.getAttribute('data-mobile-srcset');
    const sizes = picture.getAttribute('data-sizes');
    const mobileWidth = picture.getAttribute('data-mobile-width');
    const mobileHeight = picture.getAttribute('data-mobile-height');
    const img = picture.querySelector('img');

    if (!img || !fallbackSrc) return;

    if (mobileSrcset) {
      const source = document.createElement('source');
      source.media = '(max-width: 989px)';
      source.srcset = mobileSrcset;
      if (sizes) source.sizes = sizes;
      if (mobileWidth) source.width = mobileWidth;
      if (mobileHeight) source.height = mobileHeight;
      picture.insertBefore(source, img);
    }

    img.src = fallbackSrc;
    if (desktopSrcset) img.srcset = desktopSrcset;
    if (sizes) img.sizes = sizes;
    img.classList.remove('slideshow__slide-img--deferred');

    picture.removeAttribute('data-deferred-slide');
    picture.removeAttribute('data-mobile-srcset');
    picture.removeAttribute('data-desktop-srcset');
    picture.removeAttribute('data-fallback-src');
    picture.removeAttribute('data-sizes');
    picture.removeAttribute('data-mobile-width');
    picture.removeAttribute('data-mobile-height');
  }

  function hydrateDeferredSlidePictures(root) {
    if (!root) return;
    root.querySelectorAll('picture[data-deferred-slide]').forEach(hydrateDeferredSlidePicture);
  }

  function getSlides(component) {
    let slides = slidesCache.get(component);
    if (!slides) {
      slides = Array.from(component.querySelectorAll('[id^="Slide-"]:not([data-slideshow-loop-clone])'));
      slidesCache.set(component, slides);
    }
    return slides;
  }

  function onSlideChanged(event) {
    const component = event.target;
    const current = event.detail?.currentElement;
    if (!current) return;

    // Hidratar en el siguiente frame: evita escribir/leer el DOM de forma
    // sincrónica dentro del handler de scroll (bloquearía el paint de la
    // propia interacción y empeoraría el INP del carrusel).
    requestAnimationFrame(() => {
      hydrateDeferredSlidePictures(current);

      const slides = getSlides(component);
      const idx = slides.indexOf(current);
      if (idx < 0 || slides.length < 2) return;

      const next = slides[(idx + 1) % slides.length];
      if (next && next !== current) hydrateDeferredSlidePictures(next);
    });
  }

  function bindSlideshow(component) {
    if (!component || component.dataset.deferredSlidesBound === 'true') return;
    component.dataset.deferredSlidesBound = 'true';
    component.addEventListener('slideChanged', onSlideChanged);
  }

  function initSlideshows(root) {
    (root || document).querySelectorAll('slideshow-component').forEach(bindSlideshow);
  }

  window.hydrateDeferredSlidePictures = hydrateDeferredSlidePictures;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSlideshows());
  } else {
    initSlideshows();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('slideshow-component').forEach((component) => slidesCache.delete(component));
    initSlideshows(event.target);
    if (window.Shopify?.designMode) {
      hydrateDeferredSlidePictures(event.target);
    }
  });
})();
